import { createContext, useContext, useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { ADMIN_ENDPOINTS, adminFetch } from '../config';

const AdminContext = createContext(null);

export function AdminProvider() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = async () => {
    try {
      const res = await adminFetch(ADMIN_ENDPOINTS.authCheck);
      const data = await res.json();
      if (data.loggedIn) {
        setUser({ username: data.username });
      } else {
        setUser(null);
      }
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkAuth();
  }, []);

  const login = (username) => setUser({ username });
  const logout = async () => {
    await adminFetch(ADMIN_ENDPOINTS.logout, { method: 'POST' });
    setUser(null);
  };

  return (
    <AdminContext.Provider value={{ user, loading, checkAuth, login, logout }}>
      <Outlet />
    </AdminContext.Provider>
  );
}

export function useAdmin() {
  const ctx = useContext(AdminContext);
  if (!ctx) throw new Error('useAdmin must be used within AdminProvider');
  return ctx;
}
